export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const VENDER_BASE_URL = process.env.REACT_APP_VENDER_BASE_URL;
export const INSURANCES_BASE_URL = process.env.REACT_APP_INSURANCES_BASE_URL;
export const PRICINGS_URL = process.env.REACT_APP_PRICING_URL;
export const MY_DATA = 'anunciante';
export const MY_LISTINGS = 'anuncio';
export const MY_FAVORITES = 'anunciante/favoritos';
export const MY_INSURANCES = 'seguros';
export const OFFERS = 'anunciante/propostas';
export const LISTING_DATA = 'dadosicarros';
export const NPS_PATH = 'nps';
export const POPUP_PATH = 'popup';
export const NPS_FORM = `${POPUP_PATH}/${NPS_PATH}`;
